export default "__VITE_PUBLIC_ASSET__b66d4700__"